import React from 'react'
import { StyleSheet, View } from '@react-pdf/renderer'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'
import CardImage from './CardImage'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    jussifyContent: 'space-between',
    width: '100%',
    gap: 20,
    marginBottom: 22,
  },
})

const DoubleImage = ({
  title, image, title2, image2
}) => (
  <View style={styles.container}>
    <CardImage title={title} image={image} />
    <CardImage title={title2} image={image2} />
  </View>
)

DoubleImage.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image2: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
}

export default DoubleImage
